import { render, staticRenderFns } from "./user_profile_comment.vue?vue&type=template&id=834b5f12&scoped=true&"
import script from "./user_profile_comment.vue?vue&type=script&lang=ts&"
export * from "./user_profile_comment.vue?vue&type=script&lang=ts&"
import style0 from "./user_profile_comment.vue?vue&type=style&index=0&id=834b5f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834b5f12",
  null
  
)

export default component.exports